import { ScheduleState } from "../../../type/schedule-state";

export const clearPreviewDispatch = (state: ScheduleState) => {
  state.preview = [];
};
